var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "card-content" },
      [
        _c(
          "b-notification",
          {
            attrs: { type: "is-warning", active: _vm.isActive },
            on: {
              "update:active": function ($event) {
                _vm.isActive = $event
              },
              click: function ($event) {
                _vm.isActive = !_vm.isActive
              },
            },
          },
          [_vm._v("\n      " + _vm._s(_vm.error) + "\n    ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label", attrs: { for: "" } }, [
            _vm._v("Nombre de la carpeta"),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "control" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.nombre,
                  expression: "nombre",
                },
                {
                  name: "validate",
                  rawName: "v-validate",
                  value: { required: true },
                  expression: "{required:true}",
                },
              ],
              ref: "nombre",
              staticClass: "input",
              class: { "is-danger": _vm.errors.has("nombre") },
              attrs: { type: "text", name: "Nombre de la carpeta" },
              domProps: { value: _vm.nombre },
              on: {
                keyup: function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.submit()
                },
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.nombre = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _vm.invalidRenameMessage
            ? _c("p", { staticClass: "help has-text-danger" }, [
                _vm._v(_vm._s(_vm.invalidRenameMessage)),
              ])
            : _vm._e(),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "field" }, [
          _c("label", { staticClass: "label" }, [_vm._v("Heredar permisos")]),
          _vm._v(" "),
          _vm.forceHerencia
            ? _c("p", { staticClass: "is-size-7 has-text-primary mb-3" }, [
                _c("i", { staticClass: "fas fa-exclamation-triangle" }),
                _vm._v(" "),
                _c("b", [_vm._v("Nota:")]),
                _vm._v(
                  " Los documentos y carpetas de la carpeta " +
                    _vm._s(_vm.currentFolder.name) +
                    " heredarán los permisos por defecto"
                ),
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "control" },
            [
              _c(
                "b-switch",
                {
                  attrs: { size: "is-small", disabled: _vm.forceHerencia },
                  model: {
                    value: _vm.permisos,
                    callback: function ($$v) {
                      _vm.permisos = $$v
                    },
                    expression: "permisos",
                  },
                },
                [_vm._v("Heredar permisos de la carpeta superior")]
              ),
            ],
            1
          ),
        ]),
      ],
      1
    ),
    _vm._v(" "),
    _c("footer", { staticClass: "card-footer" }, [
      _c(
        "a",
        {
          staticClass: "card-footer-item",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$parent.close()
            },
          },
        },
        [_vm._v("Cancelar")]
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "card-footer-item has-text-weight-bold is-uppercase",
          class: { disabled: _vm.invalidRenameMessage },
          on: {
            click: function ($event) {
              $event.preventDefault()
              return _vm.submit()
            },
          },
        },
        [_vm._v("Crear")]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("header", { staticClass: "card-header" }, [
      _c("p", { staticClass: "card-header-title" }, [_vm._v("Crear carpeta")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }